import InfoIcon from "@/assets/colorable/info.svg?react";
import Button from "@/components/Common/Button";
import clsxm from "@/lib/clsxm";
import CreditInputField from "@/pages/plans/creditSystem/CreditInputField";
import {manageCreditsModalAtom} from "@/store/jotaiAtoms";
import {useSetAtom} from "jotai";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const CreditSystemConfig: FC<{
  className?: string;
  influencerFees?: {pro?: number | null; regular?: number | null};
  onConfirm?: (value: number | null) => void;
  onManageCredits?: (type: "add" | "remove") => void;
  value: number | null;
}> = ({className, influencerFees, onConfirm, onManageCredits, value}) => {
  const {t} = useTranslation("common");
  const setManageCreditsModal = useSetAtom(manageCreditsModalAtom);

  const openModal = (type: "add" | "remove") => {
    if (onManageCredits) {
      onManageCredits(type);
      return;
    }

    setManageCreditsModal({credits: value, influencerFees, isOpen: true, onConfirm, type});
  };

  return (
    <div className={clsxm("flex flex-col gap-2", className)}>
      <CreditInputField onClickCredits={() => openModal("add")} type="balance" typeClassName="px-4.5" value={value} />
      <span className="text-neutral-black text-xs">{t("adjust_credit_amount")}</span>
      <div className="flex gap-2">
        <Button
          buttonStyle="White"
          onClick={() => openModal("remove")}
          className="text-primary-dark-solid h-8 w-17.5 text-xl">
          -
        </Button>
        <Button buttonStyle="White" onClick={() => openModal("add")} className="text-primary-dark-solid h-8 w-17.5">
          +
        </Button>
      </div>
      <div className="bg-primary-light-solid flex items-center gap-2 rounded-md p-3">
        <InfoIcon className="text-primary-sky size-3.5 shrink-0" />
        <span className="text-neutral-black text-xs">{t("credit_system_info_currency")}</span>
      </div>
      <div className="bg-primary-light-solid flex items-center gap-2 rounded-md p-3">
        <InfoIcon className="text-primary-sky size-3.5 shrink-0" />
        <span className="text-neutral-black text-xs">{t("credit_system_info_fees")}</span>
      </div>
      <span className="text-neutral-grey-dark text-xs">{t("credit_system_careful_warning")}</span>
    </div>
  );
};

export default CreditSystemConfig;
